import { axios } from "~/plugins/request"
import Cookie from "js-cookie"
export const state = () => {
  return {
    userInfo: {},
    menuList: [],
    permissionList: []
  }
}
export const mutations = {
  SET_USER(state, userInfo) {
    state.userInfo = userInfo
  },
  SET_MENU(state, menu) {
    state.menuList = menu
  },
  SET_PERMISSION(state, permissionList) {
    state.permissionList = permissionList
  },

}
export const actions = {
  login({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`login`, params)
        .then(response => {
          if (response) {
            Cookie.set('token', response.token)
            let userInfo = {
              userId: response.userId,
              username: response.username,
              nickName: response.nickName,
              realName: response.realName,
              postName: response.postName,
              orgName: response.orgName,
              provinceCode: response.provinceCode,
              roleName: response.roleName,
              mobileNo: response.mobileNo,
              orgId: response.orgId,
              resetPasswordFlag: response.resetPasswordFlag,
              resetPasswordNewFlag: response.resetPasswordNewFlag,
              leaderName: response.leaderName,
              fwUserName: response.fwUserName,
              purchaseUserIdentification: response.purchaseUserIdentification
            }
            commit('SET_USER', userInfo);
            commit('SET_MENU', response.menuTree);
            commit("SET_PERMISSION", response.permissionList)
            Cookie.set('userInfo', userInfo)
            Cookie.set('permissionList', response.permissionList.join())
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`logout`).then(response => {
        Cookie.remove('token')
        Cookie.remove('permissionList')
        sessionStorage.clear()
        resolve(response)
      }).catch(error => {
        Cookie.remove('token')
        Cookie.remove('permissionList')
        sessionStorage.clear()
        reject(error)
      })
    })
  },
  loginPlanningPlatform({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`loginPlanningPlatform`, params)
          .then(response => {
            if (response) {
              Cookie.set('token', response.token)
              let userInfo = {
                userId: response.userId,
                username: response.username,
                nickName: response.nickName,
                realName: response.realName,
                postName: response.postName,
                orgName: response.orgName,
                provinceCode: response.provinceCode,
                roleName: response.roleName,
                mobileNo: response.mobileNo,
                orgId: response.orgId,
                resetPasswordFlag: response.resetPasswordFlag,
                resetPasswordNewFlag: response.resetPasswordNewFlag,
                leaderName: response.leaderName,
                fwUserName: response.fwUserName,
                purchaseUserIdentification: response.purchaseUserIdentification
              }
              commit('SET_USER', userInfo);
              commit('SET_MENU', response.menuTree);
              commit("SET_PERMISSION", response.permissionList)
              Cookie.set('userInfo', userInfo)
              Cookie.set('permissionList', response.permissionList.join())
            }
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
    })
  },

  getSocketLog({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`getSocketLog`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`getUserInfo`)
        .then(response => {
          if (response) {
            Cookie.set('token', response.token)
            let userInfo = {
              userId: response.userId,
              username: response.username,
              nickName: response.nickName,
              realName: response.realName,
              postName: response.postName,
              orgName: response.orgName,
              provinceCode: response.provinceCode,
              roleName: response.roleName,
              mobileNo: response.mobileNo,
              orgId: response.orgId,
              resetPasswordFlag: response.resetPasswordFlag,
              resetPasswordNewFlag: response.resetPasswordNewFlag,
              fwUserName: response.fwUserName,
              purchaseUserIdentification: response.purchaseUserIdentification
            }
            commit('SET_USER', userInfo);
            commit('SET_MENU', response.menuTree);
            commit("SET_PERMISSION", response.permissionList)
            Cookie.set('userInfo', userInfo)
            Cookie.set('permissionList', response.permissionList.join())
            sessionStorage.setItem("permissionList",response.permissionList.join())
          }
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  getPagePermission({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`getPagePermission`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
     })
  },
  updateUser({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`updateUser`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
     })
  },
  updatePassword({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`updatePassword`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
     })
  },
  getUserInfoNew({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post(`getUserInfoNew`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  checkMobile({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`checkFirstLogin`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
     })
  },
  sendMessage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`sendSmsCode`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
     })
  }
}
